<template>
<div :data-qa="dataQa">
    <template v-for="item in options">
        <block-wrap :key="item.id"
                    :adaptive="adaptive"
                    :take-width="takeWidth"
                    :step-fields-count="stepFieldsCount">
            <checkbox
                :id="id + '.' + item.id"
                :data-qa="$setQa(`${dataQa}.options.${item.id}`, {
                    checked: multiple_get(item),
                })"
                :adaptive="adaptive"
                :value="multiple_get(item)"
                :focused="focused"
                :title="(item.description || item.title || item.match)"
                @focus="() => {$emit('focus')}"
                @blur="() => {$emit('blur')}"
                @input="() => { multiple_input(item) }"/>
        </block-wrap>
    </template>

    <div v-if="validation_showError && validation_error"
         class="odr-error-message"
         :class="{
             'odr-error-message_plain': $root.appConfig.mode !== 'chat'
         }">
        {{ validation_error }}
    </div>
</div>
</template>

<script>
import '@/scss/blocks/error-message.scss';

import validationMixin from '@/utils/mixins/validation';
import focusMixin from '@/utils/mixins/focus';
import orderMixin from '@/utils/mixins/order';
import multipleMixin from '@/utils/mixins/multiple';
import checkbox from '@/vue/blocks/checkbox';

export default {
    mixins: [validationMixin, focusMixin, orderMixin, multipleMixin],
    props: {
        dataQa: {},
        value: {},
        values: {},
        title: {},
        adaptive: {},
        allValues: {},
        takeWidth: {},
        stepFieldsCount: {},
    },
    computed: {
        options () {
            let valuesIds = this.values.map(option => option.id);
            let selectedValues = (this.allValues || [])
                .filter(value => !valuesIds.includes(value.id))
                .filter(value => (this.value || []).includes(value.id));

            return this.values.concat(this.order_options(selectedValues));
        },
    },
    methods: {
        validation_isEmpty () {
            return this.multiple_selected.length === 0;
        },
    },
    components: {
        checkbox,
        'block-wrap': require('@/vue/block-wrap.vue').default,
    },
};
</script>
